/**
 * Event Catalog View
 */

import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { GRID_ROW_HEIGHT } from '@/lib/gridStyles';
import { useEventCatalog } from './hooks/useWorkflowChaining';
import { getModuleColors } from './utils/moduleColors';

export const EventCatalogView: React.FC = () => {
  const { data: events, isLoading } = useEventCatalog();

  const columns: GridColDef[] = [
    { field: 'type', headerName: 'Event', flex: 1 },
    {
      field: 'module',
      headerName: 'Module',
      width: 120,
      renderCell: (params) => {
        if (!params.value) return null;
        const colors = getModuleColors(params.value);
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{ backgroundColor: colors.border, color: 'white' }}
          />
        );
      },
    },
    { field: 'entity', headerName: 'Entity', width: 150 },
    { field: 'kind', headerName: 'Kind', width: 130 },
    { field: 'description', headerName: 'Description', flex: 2 },
    { field: 'emitterCount', headerName: 'Emitters', width: 100, type: 'number' },
    { field: 'subscriptionCount', headerName: 'Subscriptions', width: 120, type: 'number' },
  ];

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Event Catalog
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Domain events emitted by commands. Events can trigger workflow subscriptions.
      </Typography>
      <DataGridPremium
        density="compact"
        rowHeight={GRID_ROW_HEIGHT}
        rows={events || []}
        getRowId={(row) => row.fullType}
        columns={columns}
        loading={isLoading}
        autoHeight
        pageSizeOptions={[10, 25, 50]}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

/**
 * Event Detail View
 */
export const EventDetailView: React.FC = () => {
  // This would be expanded with full event details
  // For now, simplified placeholder
  return (
    <Box>
      <Typography variant="h4">Event Details</Typography>
      <Typography>Full event details view - to be implemented</Typography>
    </Box>
  );
};
